<template>
    <div class="status-bar" v-if="false">
        <span class="item">{{ tokenExpiredTimeLeftFormatted }}</span>
    </div>
</template>
<script>
export default {
    name: 'StatusBar',
    components: {},
    data() {
        return {
            // token過期剩餘時間
            tokenExpiredTimeLeft: 99999,

            // token計時器狀態開關（影響是否繼續計時）
            isTokenTimeCountingDown: false,
        };
    },

    created() {},

    mounted() {
        // 開始 token 倒數
        this.isTokenTimeCountingDown = true;
        this.tokenExpiredTimeCountDownTimer();
    },
    beforeDestroy() {},
    methods: {
        // token 過期倒數
        tokenExpiredTimeCountDownTimer() {
            if (!this.isTokenTimeCountingDown) return;

            // 計算剩餘時間
            this.tokenExpiredTimeLeft = this.$store.getters['account/expiredTime'] - Date.now();

            // 隔一秒後再次執行
            setTimeout(() => {
                this.tokenExpiredTimeCountDownTimer();
            }, 1000);
        },
    },

    computed: {
        // toke 倒數秒數格式化 (ex: 12:09)
        tokenExpiredTimeLeftFormatted() {
            const min = Math.floor(this.tokenExpiredTimeLeft / 1000 / 60);
            const sec = Math.floor((this.tokenExpiredTimeLeft / 1000) % 60);
            return sec >= 10 ? `${min}:${sec}` : `${min}:0${sec}`;
        },
    },
};
</script>
<style lang="scss" scoped="">
.status-bar {
    position: fixed;
    bottom: 0;
    right: 0;
    width: auto;
    height: 26px;
    line-height: 26px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.7);
    font-size: 10pt;
    z-index: 99999;

    .item {
        display: inline-block;
        padding: 0 10px;
        background-color: rgba(0, 0, 0, 0.5);
    }

    @media print {
        display: none;
    }
}
</style>
